import { createAction, props } from '@ngrx/store';
import { CommunityItem, CommunityTabType, FeedParams } from '../../interfaces';

export const loadTabItems = createAction(
  '[Feed] Load Tab Items',
  props<{
    tabId: CommunityTabType;
    userId: string;
    fetchParams: FeedParams;
    isFirstLoad?: boolean;
    skipLikes?: boolean;
  }>()
);

export const loadTabItemsSuccess = createAction(
  '[Feed] Load Tab Items Success',
  props<{
    tabId: CommunityTabType;
    items: CommunityItem[];
    currentPage: number;
    hasMore: boolean;
    isFirstLoad?: boolean;
  }>()
);

export const loadTabItemsFailure = createAction(
  '[Feed] Load Tab Items Failure',
  props<{ tabId: CommunityTabType; error: any }>()
);

export const setTabScrollPosition = createAction(
  '[Feed] Set Tab Scroll Position',
  props<{
    tabId: CommunityTabType;
    position: number;
    documentHeight?: number;
  }>()
);

export const clearTabData = createAction('[Feed] Clear Tab Data', props<{ tabId: CommunityTabType }>());

export const clearAllTabs = createAction('[Feed] Clear All Tabs');

export const deletePostFromTab = createAction(
  '[Feed] Delete Post From Tab',
  props<{ postId: string; tabId?: CommunityTabType }>()
);

export const setLastViewedPost = createAction(
  '[Feed] Set Last Viewed Post',
  props<{ tabId: CommunityTabType; postId: string }>()
);

export const setTargetPost = createAction(
  '[Feed] Set Target Post',
  props<{ tabId: CommunityTabType; postId: string }>()
);

export const clearTargetPost = createAction('[Feed] Clear Target Post', props<{ tabId: CommunityTabType }>());

export const setLastActiveTab = createAction('[Feed] Set Last Active Tab', props<{ tabId: CommunityTabType }>());

export const clearLastActiveTab = createAction('[Feed] Clear Last Active Tab');

export const updatePostItem = createAction(
  '[Feed] Update Post Item',
  props<{ postUuid: string; changes: Partial<CommunityItem> }>()
);
